import React from 'react';
import { connect } from 'react-redux';
import Modal from 'components/UI/Modal';
import PanelWrapper from 'components/UI/PanelWrapper';
import { alert } from 'util'
import { Button, DropdownButton, MenuItem, Table } from "components/UI"
import "containers/pages/Student/StudentTable/student-table.scss"
import Loading from 'components/UI/Loading';

class UIExamples extends React.Component {
	constructor(props) {
		super(props);
	}

  componentDidMount() {
  }

	render() {
		let fields = [
			{
				title: "Student",
				name: "sName",
				getTdProps: ({tbodyData})=>{
					return {
						className: "student-info",
						style: {
							width: "20%"
						}
					}
				},
				getTdContent: ({ trData: student })=>{
					let maleImg = require('data/images/Male_student.png');
					let femaleImg = require('data/images/Female_student.png');

					if (!student.sName) {
						return "";
					}

					return (
						<div className="student-info-container">
							<div className="portrait" style={{
									backgroundImage: student.sGender == 0 ? `url(${maleImg})` : `url(${femaleImg})`
									}}>
							</div>
							<div className="text-container">
								<div className="name">
									{student.sName}
								</div>
								<small>
									{student.sAge} yrs old
								</small>
							</div>
						</div>
					);
				},
			},
			{
				title: "Class",
				name: "className",
				getTdProps: ({tbodyData})=>{
					return {
						className: "class-info",
						style: {
							width: "20%"
						}
					}
				},
				getTdContent: ({ trData: student })=>{
					return (
						<div>
							<div className="class-info-name">
								{student.className}
							</div>
							<small>
								${student.classTotalFee}
							</small>
						</div>
					);
				},
			},
			{
				title: "Class Status",
				name: "classStatus",
			},
			{
				title: "Payment",
				name: "paidTotalFee",
			},
			{
				title: "Settings",
				name: "settings",
				getTdProps: ({tbodyData})=>{
					return {
						className: "table-setting",
						style: {
							width: "25%"
						}
					}
				},
				getTdContent: ({ trData: student })=>{
					return (
						<div>
							<Button bsStyle='link'>档案</Button>
							<Button bsStyle='link'>排班</Button>
							<Button bsStyle='link'>收费</Button>
							<Button bsStyle='link'>更多<i className="fa icon-angle-down dropdown-caret" /></Button>
						</div>
					);
				},

			},

		];

		let data = [
			[
				{ sName: "Ryan", sAge: 35, sGender: 0, className: "现代舞少儿", classTotalFee: 500, settings: "" },
				{ className: "法语绘画", classTotalFee: 3500 },
			],
			[
				{
					sName: "Billy", sAge: 23, sGender: 0, className: "麻将高手", classTotalFee: 1000, settings: ""
				},
				{
					className: "吃饭绝招儿", classTotalFee: 350
				},
			],
			[
				{
					sName: "April", sAge: 22, sGender: 1, className: "韩式料理", classTotalFee: 8500, settings: ""
				},
			],
			[
				{
					sName: "Nick", sAge: 22, sGender: 0, className: "墨西哥舞",  classTotalFee: 8500, settings: ""
				},
			],
		];

		let defaultFields = [
			{ title: "班级名称", name: "a" },
			{ title: "日期", name: "b" },
			{ title: "上课进度", name: "c" },
			{ title: "老师", name: "d" },
			{ title: "学员", name: "e" },
		]

		let defaultData = [
			{ a: "狂吃韩国料理", b: "2018 3月15日", c: "15/25", d: "金正恩", e: "352万人", },
			{ a: "狂吃韩国料理", b: "2018 3月15日", c: "15/25", d: "金正恩", e: "352万人", },
			{ a: "狂吃韩国料理", b: "2018 3月15日", c: "15/25", d: "金正恩", e: "352万人", },
			{ a: "狂吃韩国料理", b: "2018 3月15日", c: "15/25", d: "金正恩", e: "352万人", },
		]

		return (
			<PanelWrapper>
				<h1>Native UI Components</h1>
        <div style={{height: 300}}>
          <Loading />
        </div>

				<Modal 
					isShowingModal={false} 
					hasFooter={true} // flase to hide
					hasHeader={true} // false to hide 

					headerType="bold"
					headerTitle="升级高级版"
					headerIcon="fa icon-credit-card"
					
					footerType="bold"
					footerButtons={[
						{ 
							title: "升级高级版", 
							className: "btn btn-primary pull-right", 
							onClick: ()=>{
							}
						},
					]}
				>
					<div style={{ textAlign: "center", fontSize: 18, color: "#A0A4A5" }}>
						您目前的在职老师上限为20人，添加更多老师请升级为高级版
					</div>
				</Modal>
				<Table
					fields={fields}
					data={data}
					className="student-table"
					useTbodyAsRow={true}
          useMultiSelection={true}
          usePagination={false}
					onTrSelectionToggled={(params)=>{
					}}
				/>
				<Table
					fields={defaultFields}
					data={defaultData}
					useMultiSelection={true}
          usePagination={false}
					settingWidth={225}
					settings={[
						{ title: "加入班级", onClick: (opts)=>{ console.log(opts); } },
						{ title: "签到", onClick: (opts)=>{ console.log(opts); } },
						{ title: "更多", id: "table1-modify", onClick: (opts)=>{ console.log(opts); }, dropdown: [
							{ title: "修改", onClick: (opts)=>{ console.log(opts); } },
							{ title: "归档", onClick: (opts)=>{ console.log(opts); } },
						] },
					]}
					onTrSelectionToggled={(params)=>{
					}}
				/>
        

				<h3>Alerts</h3>
				<div>
					<Button bsStyle='warning' onClick={()=>{ 
						alert.warning("", "请输入电话号码", { okButtonTitle: "好的" });
						}}>warning</Button>
					<Button bsStyle='primary' onClick={()=>{ 
						alert.message("您目前的在读学员上限为50人，添加更多学员请升级为高级版", "升级高级版", { okButtonTitle: "升级高级版" });
						}}>message</Button>
					<Button bsStyle='success' onClick={()=>{ 
						alert.success("高级版本为您开放了更多的功能，赶快去体验吧！", "升级成功", { okButtonTitle: "好的" });
						}}>success</Button>
					<Button bsStyle='danger' onClick={()=>{ 
						alert.fail("无法链接服务器", "登录失败", { okButtonTitle: "好的" });
						}}>fail</Button>
					<Button bsStyle='default' onClick={()=>{ 
						alert.error("", "无法链接服务器", { okButtonTitle: "好的" });
						}}>error</Button>
				</div>
				<h1>Bootstrap UI components</h1>
				<p>We put these components just to check out their looks. For detailed documentation, please visit <a href='https://react-bootstrap.github.io/components.html' target="_blank">react-boostrap documentation.</a></p>
				<h3>Buttons</h3>
				<div>
					<Button bsStyle='primary'>primary</Button>
					<Button bsStyle='default'>default</Button>
					<Button bsStyle='success'>success</Button>
					<Button bsStyle='info'>info</Button>
					<Button bsStyle='warning'>warning</Button>
				</div>
				<div>
					<h3>DropdownButtons</h3>
					<DropdownButton bsStyle='default' title={__("Change Language", "header", null, true)} id='demo-dropdown'>
						<MenuItem eventKey="1">English</MenuItem>
						<MenuItem divider></MenuItem>
						<MenuItem eventKey="1">简体中文</MenuItem>
						<MenuItem eventKey="2">한국어</MenuItem>
					</DropdownButton>
					<DropdownButton bsStyle='default' className='btn-language' noCaret title={__("Change Language", "header", null, true)} id='demo-dropdown'>
						<MenuItem eventKey="1">English</MenuItem>
						<MenuItem divider></MenuItem>
						<MenuItem eventKey="1">简体中文</MenuItem>
						<MenuItem eventKey="2">한국어</MenuItem>
					</DropdownButton>
				</div>
			</PanelWrapper>
		);
	}
}

export default UIExamples



// WEBPACK FOOTER //
// ./src/containers/pages/UILibrary/index.js